import { Stack, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { DATE_FORMAT } from '../../../../utils/constants';
import { identifyAndConvertDate } from '../../../../utils/formatTime';

const useLicenseList = () => {
  const accountLicensesData = useSelector((state) => state.accountLicenses);
  const packageListData = useSelector((state) => state.packageList?.packageMenuList);

  function getNameById(id) {
    const found = packageListData?.find((item) => item.packageId === id);
    return found ? found.packageLabel : id;
  }

  const columns = [
    {
      field: 'name',
      headerName: 'License',
      sortable: true,
      filterable: false,
      flex: 1.5,
      renderCell: (params) => (
        <Stack direction="column">
          <Typography variant="body2">{params.value}</Typography>
          <Typography variant="body2" color="text.secondary">{getNameById(params.row.packageId)}</Typography>
        </Stack>
      ),
    },
    {
      field: 'licenseStatus',
      headerName: 'Status',
      flex: 0.8,
      sortable: true,
      filterable: false,
    },
    {
      field: 'expirationDate',
      headerName: 'Expiration',
      flex: 1,
      sortable: true,
      filterable: false,
      renderCell: (params) => (
        <span>{params.row.expiration ? identifyAndConvertDate(params.row.expiration, DATE_FORMAT.DAY_DATE_GRAPH, 'YYYY-MM-DD') : params.row.expirationDate}</span>
      ),
    },
    {
      field: 'seatsAssignment',
      headerName: 'Seats Assigned',
      flex: 1,
      sortable: true,
      filterable: false,
      renderCell: (params) => {
        const { row: { seats, usedLicense } } = params;
        if (Number(seats) === -1) {
          return 'Site-Wide';
        }
        return `${usedLicense} of ${seats}`;
      },
    },
  ];

  return {
    columns,
    data: accountLicensesData?.data ? accountLicensesData.data : [],
  };
};

export default useLicenseList;
